import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'usuarios',
    loadChildren: () => import('./pages/usuarios/usuario.module').then( m => m.UsuarioPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'empresas',
    loadChildren: () => import('./pages/empresas/empresas.module').then( m => m.EmpresasPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'projetos',
    loadChildren: () => import('./pages/projetos/projetos.module').then( m => m.ProjetosPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'tarefas/:id',
    loadChildren: () => import('./pages/tarefas/tarefas.module').then( m => m.TarefasPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'contatos',
    loadChildren: () => import('./pages/contatos/contatos.module').then( m => m.ContatosPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'relatorio/projetos',
    loadChildren: () => import('./pages/relatorios/projetos/projetos.module').then( m => m.ProjetosPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'relatorio/tarefas',
    loadChildren: () => import('./pages/relatorios/tarefas/tarefas.module').then( m => m.TarefasPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'tarefas',
    loadChildren: () => import('./pages/tarefas-geral/tarefas-geral.module').then( m => m.TarefasGeralPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'configuracoes/geral',
    loadChildren: () => import('./pages/configuracoes/geral/geral.module').then( m => m.GeralPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'configuracoes/senha',
    loadChildren: () => import('./pages/configuracoes/senha/senha.module').then( m => m.SenhaPageModule),
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
